(function () {
  var HIDE_STRINGS = ['from Amazon', 'on Amazon', 'From Amazon', 'On Amazon'];

  var HIDE_CSS =
    '[class*="attribution"],[class*="branding"],[class*="source"],' +
    '[class*="powered"],[class*="amazon-link"],[class*="on-amazon"],' +
    'a[href*="amazon.com/dp"],a[href*="amazon.com/product"]' +
    '{ display:none!important }';

  // Star rating widget — Rift bold uppercase to match product-info label style.
  // Product pages get 0.875rem; collection cards get a smaller size, since the
  // rating is supporting information there rather than a headline stat.
  function ratingCss(fontSize) {
    return ':host, * { font-family: "Rift", sans-serif !important; font-weight: 700 !important; ' +
      'font-size: ' + fontSize + ' !important; letter-spacing: 0.12em !important; ' +
      'text-transform: uppercase !important; color: rgba(23,23,23,0.65) !important; }';
  }

  // Collection cards: stars + count only, typed to match .product-card__subtitle.
  //
  // .rating-number must be hidden by SELECTOR, not by matching its text. Hiding
  // the text node's element left the .rating-number container in place as a 4px
  // sliver, and because .rating-section is a flex row that sliver pushed the
  // stars 4px right of the title — which is why they would not line up.
  //
  // The stars are <img>, not glyphs, so font-size does nothing to them; they
  // have to be sized explicitly.
  var CARD_RATING_CSS =
    ':host, * { font-family: "Rift", sans-serif !important; }' +
    '.rating-number { display: none !important; }' +
    // Sizes come from custom properties set on the host in custom.css.
    // Custom properties inherit across the shadow boundary (verified), so the
    // responsive tuning lives with the rest of the card CSS instead of being
    // baked into this string, where a media query would be awkward.
    '.star-style { width: var(--pf-card-star-size, 14px) !important; ' +
    '              height: var(--pf-card-star-size, 14px) !important; }' +
    '.star-rating { margin: 0 6px 0 0 !important; }' +
    // count text — same treatment as the card subtitle
    ':host, .rating-container, .rating-section, span, p, div { ' +
    '  font-size: var(--pf-card-rating-size, 12px) !important; font-weight: 500 !important; ' +
    '  letter-spacing: 1.2px !important; text-transform: uppercase !important; ' +
    '  color: rgba(23,23,23,0.6) !important; }';

  // Full reviews section — Gotham readable body text
  // Heading forced to span full widget width, flush left, above the rating columns
  var REVIEWS_CSS =
    ':host { padding: 0 !important; margin: 0 !important; }' +
    ':host, * { font-family: "Gotham", sans-serif !important; font-weight: 400 !important; ' +
    'font-size: var(--text-sm) !important; letter-spacing: normal !important; ' +
    'color: rgba(23,23,23,0.85) !important; }' +
    'h1, h2, h3 { ' +
    '  grid-column: 1 / -1 !important; flex-basis: 100% !important; ' +
    '  width: 100% !important; max-width: 100% !important; ' +
    '  text-align: left !important; ' +
    '  margin: 0 0 1rem 0 !important; padding: 0 !important; ' +
    '  order: -1 !important; align-self: start !important; ' +
    '}';

  function patchRoot(root, tag, host) {
    // processExisting() runs again at 500ms and 2000ms and can reach a root that
    // was already patched via attachShadow. Without this guard each pass would
    // add another <style> and another MutationObserver to the same root — and
    // now that the observer re-appends the style, stacked observers would each
    // react to the others' work.
    if (root.__pfPatched) return;
    root.__pfPatched = true;

    var inCard = !!(host && host.closest && host.closest('.product-card'));
    var style = document.createElement('style');
    style.textContent =
      (tag === 'amazon-product-rating'
        ? (inCard ? CARD_RATING_CSS : ratingCss('0.875rem'))
        : REVIEWS_CSS) + HIDE_CSS;
    root.appendChild(style);

    function processText() {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
      var node;
      while ((node = walker.nextNode())) {
        var val = node.nodeValue || '';
        // Hide Amazon attribution text
        if (HIDE_STRINGS.some(function (s) { return val.indexOf(s) !== -1; })) {
          var parent = node.parentElement;
          if (parent) parent.style.setProperty('display', 'none', 'important');
        }
        // Suppress "bought in past month" count entirely
        if (tag === 'amazon-product-rating' && val.toLowerCase().indexOf('bought') !== -1 &&
            (val.toLowerCase().indexOf('month') !== -1 || val.toLowerCase().indexOf('past') !== -1 || val.toLowerCase().indexOf('last') !== -1)) {
          var sourceEl = node.parentElement;
          if (sourceEl) sourceEl.style.setProperty('display', 'none', 'important');
        }

        // (The numeric score is hidden by selector in CARD_RATING_CSS. Hiding it
        // by text node here is what left a 4px sliver misaligning the stars.)
      }
    }

    // The widget re-renders its shadow content and REMOVES this style element
    // when it does. Nothing used to put it back, so cards silently reverted to
    // Amazon's default look — numeric score visible again, Gotham instead of
    // Rift, 18px stars — and whether a card looked right depended purely on
    // whether you saw it before or after that re-render. Re-append on every
    // mutation; appending an element already in the tree is a no-op move, so
    // the containment check keeps this from thrashing.
    function reapply() {
      if (!root.contains(style)) root.appendChild(style);
      processText();
    }

    new MutationObserver(reapply).observe(root, { childList: true, subtree: true });
    processText();
  }

  // === KEY: intercept attachShadow before Amazon scripts run ===
  var _attachShadow = Element.prototype.attachShadow;
  Element.prototype.attachShadow = function (init) {
    var root = _attachShadow.call(this, Object.assign({}, init, { mode: 'open' }));
    var el = this;
    setTimeout(function () {
      var tag = el.tagName && el.tagName.toLowerCase();
      if (tag === 'amazon-product-rating' || tag === 'amazon-product-reviews') {
        patchRoot(root, tag, el);
      }
    }, 0);
    return root;
  };

  // Fallback: catch any roots that were already open
  function processExisting() {
    ['amazon-product-rating', 'amazon-product-reviews'].forEach(function (tag) {
      document.querySelectorAll(tag).forEach(function (el) {
        if (el.shadowRoot) patchRoot(el.shadowRoot, tag, el);
      });
    });
  }
  setTimeout(processExisting, 500);
  setTimeout(processExisting, 2000);
})();
